
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = $('body').data('money-format');
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function changeComparePrice(time){
  $('.product__info-container .price__loader').show();
  $('.product__info-container .price__regular').hide();
  setTimeout(function() {

    var count=0;
    var x=setInterval(function(){

    var price = $('.product__info-container .price__regular .price-item--regular').data('price');

    $('.gpo-element .gpo-swatches input[type="radio"]:checked').each(function(i, obj) {
      var price_addon = $(this).closest('.gpo-element').find('.gpo-label span.addOn').text();
      price_addon = price_addon.replace(" ", "").replace("(", "").replace(")", "").replace("+$","").replace("+£","").replace("+€","").replace(",",".");
     // console.log(price_addon);
      price_addon = price_addon * 100;
     // console.log(price_addon);
      price = parseInt(price) + price_addon;
    });

    $('.spice-spa-addon-product-item').each(function(i, obj) {
      var checkbox = $(this).find('.spice-spa-addon-checkbox-input:checked');
      if (checkbox.length > 0){
         var variant_price =  $(this).find('.spice-spa-addon-price-main').attr('variant_price');
         var variant_quantity =  $(this).find('[name="sg-pro-access-qty"]').val();
        variant_price = parseInt(variant_price) * variant_quantity;
        console.log(variant_price);
        price = parseInt(price) + variant_price;
      }
    });

    var percent_price = $('.product__info-container .price__regular .price-item--regular').data('percent');
    var calculator_price = (100 - percent_price) * 0.01;
    var compare_price = price / calculator_price; 

      $('.product__info-container .price__regular .price-item--regular').text(Shopify.formatMoney(price, $('body').data('money-format')));
      $('.product__info-container .price__regular .price-item--sale').text(Shopify.formatMoney(compare_price, $('body').data('money-format')));
      
      if(count > 5){
      //  console.log('stop Interval');
        clearInterval(x);
        $('.product__info-container .price__loader').hide();
        $('.product__info-container .price__regular').show();
      }
      count++;
    }, time);
    
  }, 1000);
}

function changeBackground(){
  setTimeout(function() {
    var pictureType = $('input[name="Select Picture Style"]:checked').val();
    var premadeBackground = $('input[name="Select Background"]:checked').val();
    
    var combined = pictureType +' - '+ premadeBackground;
    combined = combined.toLowerCase().replace("'", "").replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    if(combined != ''){
      var sectionID = $('#product-section-id').val();                           
      var imageID = $('.img-'+combined).data('image-id');
      const mediaGallery = document.getElementById('MediaGallery-'+sectionID);
      mediaGallery.setActiveMedia(sectionID+'-'+imageID, true);
      const modalContent = document.querySelector('#ProductModal-'+sectionID+' .product-media-modal__content');
      const newMediaModal = modalContent.querySelector('[data-media-id="'+imageID+'"]');
      modalContent.prepend(newMediaModal);
    }
    
  }, 300);
}

function changeAddonAdditionalInfo(){

  $('.spice-spa-addon-product-item').each(function(i, obj) {
    var checkbox = $(this).find('.spice-spa-addon-checkbox-input:checked');
    if (checkbox.length > 0){
   
      var AdditionalField =  $(this).find('.spice-spa-addon-product-text-field');
      if (AdditionalField.length > 0){
      
        var pid= $(this).find('.spice_properties');               
        var headingName = $('.product__info-container .product__title').text();
        var numberValue = $('input[name="Select Number of People and Pets"]:checked').val();
        var styleValue = $('input[name="Select Picture Style"]:checked').val();
        var backgroundValue = $('input[name="Select Background"]:checked').val();

        var stringInfo = $.trim(headingName);
             
        if(numberValue != ''){
          stringInfo += ' - ' + numberValue;
        }
        if(styleValue != ''){
          stringInfo += ' - ' + styleValue;
        }
        if(backgroundValue != ''){
          stringInfo += ' - ' + backgroundValue;
        }
        pid.text(stringInfo);
      }
    }
  });
  
}

function checkRequiredFields(){
  var check_error = false;
  $('.gpo-form__group.show-addon-for-option').each(function(i, obj) {
    if($(this).hasClass("has-error")){
      check_error = true;
    }
  });  
  if(!check_error){
    $('button.product-form__submit').attr('disabled',false);
  }else{
    $('button.product-form__submit').attr('disabled',true);
    $('input.spice-spa-addon-checkbox-input').each(function(i, obj) {
      $(this).prop("checked",false);
    });
  }
}

// Fix malformed blog/page image src values (some entries were saved as pipe-delimited blobs).
function fixTurnedYellowMagazineImages() {
  if (typeof window === 'undefined') return;

  const pathname = window.location.pathname || '';
  if (!pathname.includes('/pages/love-of-yellow-fan-magazine') && !pathname.includes('/blogs/turned-yellow')) {
    return;
  }

  const ALT_FALLBACKS = {
    // Top 3 fan-favorite cards
    'Yellow Cartoon Characters': 'https://cdn.shopify.com/s/files/1/0203/3280/6208/t/46/assets/blog-order_16060_5d3702405d83610017a4ffc1_700x.png',
    'AI vs Human Artists': 'https://cdn.shopify.com/s/files/1/0203/3280/6208/t/46/assets/blog-order_16407_5d7ba485a4b56600176be4f4_700x.jpg',
    // Explicit man + woman couple
    'Couples Portraits': 'https://cdn.shopify.com/s/files/1/0203/3280/6208/t/46/assets/blog-order_17209_5d35c48ca7c96c0017bb2d15_700x.jpg',

    // Gift-guide cards
    // Keep this as a broad portrait example
    'Commission Art': 'https://cdn.shopify.com/s/files/1/0203/3280/6208/t/46/assets/blog-wedding_700x.jpg',
    // Family-oriented image for kids gifts
    'Kids Gifts': 'https://cdn.shopify.com/s/files/1/0203/3280/6208/t/46/assets/blog-order_17236_5d35a428a7c96c0017ba9e5d_700x.png',
    // Distinct portrait for corporate gifting card
    'Corporate Gifts': 'https://cdn.shopify.com/s/files/1/0203/3280/6208/t/46/assets/blog-order_17252_5d41923387875c0017135e5d_700x.png'
  };

  const looksLikeImageUrl = (value) => {
    if (!value || typeof value !== 'string') return false;
    const v = value.trim();
    return /^https?:\/\//i.test(v) && /\.(jpg|jpeg|png|webp|gif)(\?.*)?$/i.test(v);
  };

  document.querySelectorAll('img[src]').forEach((img) => {
    const alt = (img.getAttribute('alt') || '').trim();
    const raw = img.getAttribute('src') || '';

    if (ALT_FALLBACKS[alt]) {
      img.src = ALT_FALLBACKS[alt];
      return;
    }

    if (!raw.includes('|')) return;

    const candidates = raw.split('|').map(s => s.trim());
    const clean = candidates.find(looksLikeImageUrl);
    if (clean) {
      img.src = clean;
    }
  });
}

$( window ).on( "load", function() {
  fixTurnedYellowMagazineImages();
  setTimeout(fixTurnedYellowMagazineImages, 800);

  // custom dropdown Number of People and Pets
  setTimeout(function() {
    $('#custom-dropdown').change(function(){
      console.log($(this).val());
      const number = $(this).val();
      $('input[name="Select Number of People and Pets"][value="'+number+'"]').prop('checked', true);
    });

    $('#custom-dropdown-gift').change(function(){
      console.log($(this).val());
      const giftVal = $(this).val();
      $('input[name="Denominations"][value="'+giftVal+'"]').prop('checked', true);
    });

    
  }, 500);  

  $('.gpo-element .gpo-swatches input[type="radio"]').click(function(){
    changeComparePrice(200);
    changeAddonAdditionalInfo();
    setTimeout(function() {
      checkRequiredFields();
    }, 500);
  });
  
  $('input[name="Select Background"]').click(function(){
    changeBackground();
    changeComparePrice(200);
    changeAddonAdditionalInfo();
    checkRequiredFields();
  });
  
  $('input[name="Select Picture Style"]').click(function(){
    changeBackground();
    changeComparePrice(200);
    changeAddonAdditionalInfo();
    setTimeout(function() {
      checkRequiredFields();
    }, 1000);
  });
  
  $('input[name="Select Number of People and Pets"]').click(function(){
    changeComparePrice(200);
    changeAddonAdditionalInfo();
    setTimeout(function() {
      checkRequiredFields();
    }, 1000);
  });

  setTimeout(function() {

    if($('.gpo-element .gpo-swatches input[type="radio"]').length > 0){
      changeComparePrice();
    }
    
    $('.gpo-swatches.image-swatches .gpo-tooltip').each(function(i, obj) {
      var title = $(this).find('span:first-child').text();
      var proOptionTitle = $('.product__info-wrapper .holiday_text').data('option-title');
      var holidayText = $('.product__info-wrapper .holiday_text').text();

       // Convert the string to an array and trim white spaces
      var arrayOption = proOptionTitle.split(',').map(function(item) {
          return item.trim();
      });

      if ($.inArray(title, arrayOption) !== -1) {
        console.log(title + " is found in the array.");
        title += '<span>('+holidayText+')</span>';
      }
        /*
      if(title.indexOf(proOptionTitle) != -1){
        title += '<span>('+holidayText+')</span>';
      }
    
      if(title.indexOf('Fathers Day') != -1){
        title += '<span>(LIMITED TIME ONLY)</span>';
      }
      */
      var price = $(this).find('span.addOn').text();
      price = price.replace(" ", "").replace("(", "").replace(")", "");
      if(price == ''){
       price = '+' + Shopify.formatMoney(0, $('body').data('money-format')); 
      }
      var compare_price = 0;
      var variant_id = $(this).parent().prev().attr('gpo-data-variant-id');
      /*
      for (var i = 0; i < addonItems.length; i++) {
        if(variant_id == addonItems[i][0]['id']){
          compare_price = addonItems[i][0]['compare_at_price'];
          if(compare_price == null){
            var itemPrice = addonItems[i][0]['price'];
            var percent_price = $('.product__info-container .price__regular .price-item--regular').data('percent');
            var calculator_price = (100 - percent_price) * 0.01;
            compare_price = itemPrice / calculator_price; 
          }
        }
      }
      //compare_price = compare_price / 100;
      console.log(compare_price);
      */

       var enable_compare_price = $('form.main-product-form').data('enable-compare-price');
      console.log(enable_compare_price);
      
      if(compare_price > 0 && enable_compare_price){
        $(this).parent().append("<div class='gpo-product-option-title'>"+title.toUpperCase()+ "</div>" + "<div class='gpo-product-price'>"+price+" <del>"+Shopify.formatMoney(compare_price, $('body').data('money-format'))+"</del>"+"</div>");
      }else{
        $(this).parent().append("<div class='gpo-product-option-title'>"+title.toUpperCase()+ "</div>" + "<div class='gpo-product-price'>"+price+"</div>");
      }
    });

    /* Update Step # for each Section */
    // Step 1 & 2 
    var step = 0;
    $('.gpo-element.gpo-form__group').each(function(i, obj) {
      step = i+1;
      var label_text = $(this).find('.label-content').text();
      label_text = "STEP "+step+": "+label_text;
      $(this).find('.label-content').text(label_text);
    });
    // Step 3
    step +=1;
    var select_number_text = $('.product-form__input.select-number-of-people-and-pets').find('.form__label').text();
    select_number_text = "STEP "+step+": "+select_number_text;
    $('.product-form__input.select-number-of-people-and-pets').find('.form__label').text(select_number_text);
    $('.product-form__input.select-number-of-people-and-pets-custom-dropdown').find('.form__label').text(select_number_text);
    // Step 4
    step +=1;
    var select_style_text = $('.product-form__input.select-picture-style').find('.form__label').text();
    select_style_text = "STEP "+step+": "+select_style_text;
    $('.product-form__input.select-picture-style').find('.form__label').text(select_style_text);
    // Step 5
    step +=1;
    var upload_text = $('.uploadkit .uploadkit-label').text();
    upload_text = "STEP "+step+": "+upload_text;
    $('.uploadkit .uploadkit-label').text(upload_text);
    //Step 6
    step +=1;
    var addons_text = $('#spiceaddonsappid .spice-spa-addon-heading').text();
    //addons_text = "STEP "+step+" (OPTIONAL): "+addons_text;
    addons_text = "STEP "+step+": "+addons_text;
    $('#spiceaddonsappid .spice-spa-addon-heading').text(addons_text);
    
  }, 300);
    
  var windowWidth = $(window).width();
  if (windowWidth <= 750 && $('.product-form__submit').length > 0) {
    $(window).scroll(function() {

      if ($(this).scrollTop() > 106 ) {
        //$('.product__media-wrapper').addClass("sticky");
        //$('.product__info-wrapper').addClass("sticky");
        $('.product__media-wrapper').addClass("preview");
        $('.product__info-wrapper').addClass("preview");
      }else{
        //$('.product__media-wrapper').removeClass("sticky");
        //$('.product__info-wrapper').removeClass("sticky");
        $('.product__media-wrapper').removeClass("preview");
        $('.product__info-wrapper').removeClass("preview");
      }

      if ($(this).scrollTop() > $('.product-form__submit').offset().top ) {
        //$('.product__media-wrapper').removeClass("sticky");
        //$('.product__info-wrapper').removeClass("sticky");
        $('.product__media-wrapper').removeClass("preview");
        $('.product__info-wrapper').removeClass("preview");
      }

    });
  }
  

});

$(window).on('resize', function() {
  var windowWidthResize = $(window).width();
  if (windowWidthResize <= 750 && $('.product-form__submit').length > 0) {
    $(window).scroll(function() {

      if ($(this).scrollTop() > 106 ) {
        $('.product__media-wrapper').addClass("preview");
        $('.product__info-wrapper').addClass("preview");
      }else{
        $('.product__media-wrapper').removeClass("preview");
        $('.product__info-wrapper').removeClass("preview");
      }

      if ($(this).scrollTop() > $('.product-form__submit').offset().top ) {
        $('.product__media-wrapper').removeClass("preview");
        $('.product__info-wrapper').removeClass("preview");
      }
      
     });
  }
});  


$('.hero__reviews').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots:true,
  autoplay:true,
  autoplaySpeed:3500,
  fade: false
});



$window = $(window);
$slick_slider = $('.js-text-slider');
settings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  arrows: true,
  nextArrow: '<span class="arrow-next arrow-btn"><i class="fa fa-angle-right" aria-hidden="true"></i></span>',
  prevArrow: '<span class="arrow-prev arrow-btn"><i class="fa fa-angle-left" aria-hidden="true"></i></span>',

};
$slick_slider.slick(settings);

$( window ).on( "load", function() {
  if ($window.width() > 991) {
    if ($slick_slider.hasClass('slick-initialized'))
      $slick_slider.slick('unslick');
    return
  }
});

$window.on('resize', function() {
  if ($window.width() > 991) {
    if ($slick_slider.hasClass('slick-initialized'))
      $slick_slider.slick('unslick');
    return
  }
  if ( ! $slick_slider.hasClass('slick-initialized'))
    return $slick_slider.slick(settings);
});  
                            
$(function() {
    var stickyBtn = $(".sticky-btn-bottom");
    var s = $("#MainContent");
    var pos = s.position();

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll > pos.top) {
            stickyBtn.addClass("active");
        } else {
            stickyBtn.removeClass("active");
        }
    });
});

$(window).scroll(function () {
  /*
  var priceSection = $('.price-section');
  if (priceSection.length) {
   const checkScrollToDiv = $('.price-section').offset().top + $('.price-section').outerHeight();
    if ($(window).scrollTop() >= checkScrollToDiv) {
      $('.price-section .price').addClass('active-sticky');
    }else if($(window).scrollTop() < $('.price-section .price').offset().top + $('.price-section .price').outerHeight()){
      $('.price-section .price').removeClass('active-sticky');
    }
  }
  */
}); 

